export default "__VITE_ASSET__f28d8bc6__"